import { IMatomo } from "@mrdm-self-service-frontend/shared/types";

const MATOMO_SETTINGS: IMatomo = {
    siteId: 79,
    organizationDimensionId: 1,
    registryDimensionId: 2,
};

export class SelfServiceMockEventTracer {
    private readonly _matomoConfig = MATOMO_SETTINGS;

    setOrganization(organization: number): void {
        //
    }

    setOrganizationName(organizationName: string): void {
        //
    }
}
